export default __webpack_public_path__ + "static/media/atd-logo.a087cc93.svg";